import * as Mod1 from "./discourse/initializers/checklist";
import * as Mod2 from "./lib/discourse-markdown/checklist";
import * as Mod3 from "./lib/rich-editor-extension";
const compatModules = {
  "discourse/initializers/checklist": Mod1,
  "lib/discourse-markdown/checklist": Mod2,
  "lib/rich-editor-extension": Mod3,
};
export { compatModules };
export default compatModules;
